export const scanBot = {
    licenseKey :
  "MFWjCAHKYh/qBElKthShlpvTXqmmwW" +
  "VYAnVPjUWrGNnTq+Vb2jqND/I6y+Bz" +
  "zu3hiENhdpUr+Ks84NkZF7TOxGeUJw" +
  "OGSqg4iiuE5cwMo4kYmhYNpiy3pi2d" +
  "TUqcG/2auODkqTsteKAwBEzZKGeUza" +
  "RixhubpGSumCbIfQCLzclh+f9uYMne" +
  "8g774cuP4A4T4Cb7fRUSF3czm60fPX" +
  "N+HvKtD2gOf9ow67c0QL85eLtrWQBu" +
  "+BNviewBTOkyx4bm1BE82Gz8VyuGGT" +
  "D1nZL2JqZB1sVPzPpU3r1gc+YlhstI" +
  "jvRYNzmyPBrm7xb15htoTeUCRKd2kM" +
  "H5z642bT56zg==\nU2NhbmJvdFNESw" +
  "pzdnAuZnRyLmNvbXxtdHBuLmZ0ci5j" +
  "b218YW1wbi5mdHIuY29tfGFtcG4tcW" +
  "F0MDEuZnRyLmNvbXxtdHBuLXFhdDAx" +
  "LmZ0ci5jb218c3ZwLXFhdDAxLmZ0ci" +
  "5jb218YW1wbi1xYXQwMi5mdHIuY29t" +
  "fG10cG4tcWF0MDIuZnRyLmNvbXxzdn" +
  "AtcWF0MDIuZnRyLmNvbXxhbXBuLXFh" +
  "dDAzLmZ0ci5jb218bXRwbi1xYXQwMy" +
  "5mdHIuY29tfHN2cC1xYXQwMy5mdHIu" +
  "Y29tfGFtcG4tcWF0MDQuZnRyLmNvbX" +
  "xtdHBuLXFhdDA0LmZ0ci5jb218c3Zw" +
  "LXFhdDA0LmZ0ci5jb218bG9jYWxob3" +
  "N0CjE3OTY3NzQzOTkKODM4ODYwNwo4" +
  "\n"
  };